import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import type { Comic } from '@/mocks/comics';
import SectionHeader from '@/components/base/SectionHeader';

const byId = (id: string): Comic => {
  const found = comics.find((c) => c.id === id);
  return found as Comic;
};

const hotList = ['jsrj', 'myyt', 'mjscj', 'sybld', 'jyx'].map(byId);
const rateList = ['myyt', 'mjscj', 'jsrj', 'sybld', 'xyt'].map(byId);

function RankingList({ list, tone }: { list: Comic[]; tone: 'primary' | 'accent' }) {
  return (
    <ol className="flex flex-col gap-2.5">
      {list.map((comic, index) => (
        <li key={comic.id}>
          <Link
            to={`/comic/${comic.id}`}
            className="group flex items-center gap-3 rounded-xl bg-background-50 p-2.5 transition-colors hover:bg-background-100"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base text-background-50 ${
                index === 0
                  ? 'bg-primary-500'
                  : index === 1
                    ? 'bg-primary-400'
                    : index === 2
                      ? 'bg-accent-500'
                      : 'bg-secondary-300 text-secondary-900'
              }`}
            >
              {index + 1}
            </span>
            <div className="h-14 w-11 shrink-0 overflow-hidden rounded-md">
              <img
                src={comic.cover}
                alt={`《${comic.title}》漫画封面`}
                title={`《${comic.title}》漫画在线免费阅读`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
                {comic.title}
              </p>
              <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                <span className={tone === 'primary' ? 'text-accent-600' : 'text-primary-600'}>
                  <i className="ri-star-fill mr-0.5"></i>
                  {comic.rating}
                </span>
                <span className="truncate">{comic.latestChapter}</span>
              </p>
            </div>
          </Link>
        </li>
      ))}
    </ol>
  );
}

export default function HotRanking() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          title="热门排行榜"
          subtitle="根据读者人气与评分实时生成"
          moreTo="/category?sort=hot"
        />
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="rounded-2xl bg-background-50 p-5">
            <h3 className="mb-4 flex items-center gap-2 text-base font-semibold text-foreground-900">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-sm"></i>
              </span>
              本周人气榜
            </h3>
            <RankingList list={hotList} tone="primary" />
          </div>
          <div className="rounded-2xl bg-background-50 p-5">
            <h3 className="mb-4 flex items-center gap-2 text-base font-semibold text-foreground-900">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-heart-3-fill text-sm"></i>
              </span>
              好评口碑榜
            </h3>
            <RankingList list={rateList} tone="accent" />
          </div>
        </div>
      </div>
    </section>
  );
}